import { createSlice } from '@reduxjs/toolkit'

export const initialState = {
  error: null,
  isFetchingUserNetSuiteAssets: false,
  isFetchingUserSites: false,
  netSuiteAssets: null,
  searchCriteria: null, // { key: value } pairs for searching assets
  sites: null,
}

const slice = createSlice({
  name: 'ssapiManager',
  initialState,
  reducers: {
    clearErrors: state => {
      state.error = null
    },
    fetchingUserSites: state => {
      state.error = null
      state.isFetchingUserSites = true
    },
    fetchingUserSitesSuccess: (state, action) => {
      state.sites = action.payload
      state.isFetchingUserSites = false
      state.error = null
    },
    fetchingUserSitesError: (state, action) => {
      state.error = action.payload
      state.isFetchingUserSites = false
    },
    fetchingUserNetSuiteAssets: state => {
      state.error = null
      state.isFetchingUserNetSuiteAssets = true
    },
    fetchingUserNetSuiteAssetsSuccess: (state, action) => {
      state.netSuiteAssets = Object.assign(
        {},
        state.netSuiteAssets,
        Object.fromEntries(
          action.payload?.map(asset => [asset.id, asset]) || [],
        ),
      )
      state.isFetchingUserNetSuiteAssets = false
      state.error = null
    },
    fetchingUserNetSuiteAssetsError: (state, action) => {
      state.error = action.payload
      state.isFetchingUserNetSuiteAssets = false
    },
    setSearchQuery: (state, action) => {
      if (
        action.payload === null ||
        (action.payload.key === undefined && action.payload.value === null)
      ) {
        // Clear all search criteria
        state.searchCriteria = null
      } else if (action.payload.key && action.payload.value !== undefined) {
        // Set specific key-value pair
        state.searchCriteria = {
          ...state.searchCriteria,
          [action.payload.key]: action.payload.value,
        }
      }
    },
    updateSitePacingDates: (state, action) => {
      const {
        siteId,
        pacingDates,
        programName,
        schoolYearEndDateString,
      } = action.payload
      if (!Array.isArray(state.sites)) return

      const siteIndex = state.sites.findIndex(site => site?.id === siteId)
      if (siteIndex !== -1) {
        const site = state.sites[siteIndex]
        state.sites[siteIndex] = {
          ...site,
          pacing: {
            ...(site.pacing || {}),
            [programName]: pacingDates,
          },
          schoolYearEndDate: schoolYearEndDateString,
        }
      }
    },
    updateSitesMspOptIn: (state, action) => {
      const { payload: mspOptInArr } = action
      if (
        !Array.isArray(state.sites) ||
        !Array.isArray(mspOptInArr) ||
        mspOptInArr.length === 0
      ) {
        return state
      }

      return {
        ...state,
        sites: state.sites.map(site => {
          const matchingSite = mspOptInArr.find(m => m.siteId === site.id)

          const newValue =
            matchingSite?.sitePreferences?.mspDigital
              ?.bullyingHarassmentUnitEnabled

          if (
            !matchingSite ||
            newValue === undefined ||
            !Array.isArray(site.preferences)
          ) {
            return { ...site }
          }

          return {
            ...site,
            preferences: site.preferences.map(preference =>
              preference?.accessCode === 'mspDigital' &&
              preference?.name === 'BullyingHarassmentUnitEnabled'
                ? { ...preference, value: newValue }
                : { ...preference },
            ),
          }
        }),
      }
    },
    updateSitePreferences: (state, action) => {
      const { siteId, preferences } = action.payload
      if (!Array.isArray(state.sites) || !Array.isArray(preferences)) return

      const siteIndex = state.sites.findIndex(site => site?.id === siteId)
      if (siteIndex !== -1) {
        state.sites[siteIndex] = {
          ...state.sites[siteIndex],
          preferences,
        }
      }
    },
  },
})

export const actions = slice.actions
export default slice.reducer
